import React from 'react'
import {Button, VStack} from '@chakra-ui/react'
import {FieldInput} from '../field-input'
import {RepeatIcon} from '@chakra-ui/icons'

export const OptionalFieldInput = ({label, name, componentType, size}: any) => {
  const [isDisabled, setIsDisabled] = React.useState(true)
  return (
    <VStack w="full" alignItems="flex-start" position="relative">
      <FieldInput size={size} name={name} label={label} componentType={componentType} disabled={isDisabled} />
      <Button
        onClick={() => {
          setIsDisabled(!isDisabled)
        }}
        top={3}
        right={0}
        position="absolute"
        leftIcon={<RepeatIcon />}
        aria-label={'has changed'}
        colorScheme={isDisabled ? 'gray' : 'primary2'}
        size="xs">
        Update
      </Button>
    </VStack>
  )
}
